export default "__VITE_ASSET__7BqTU1yG__"